export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00985.bffd51ed.png";